import BobjectFormSkeleton from './bobjectFormSkeleton.view';

export default BobjectFormSkeleton;
